<template>
  <tr v-if="extentions.length" class="test-result-row" :data-nutrient="item.type">
    <td class="nutrient">
      <app-sel
        styling="inline"
        key-name="label"
        v-if="isSeveralTyped"
        v-model="selected"
        :items="nutrient.types"
      >
        <template v-slot="{ items }">
          <app-sel-opt
            :value="nut"
            v-for="nut in items"
          >
            {{ nut.label }}
          </app-sel-opt>
        </template>
      </app-sel>
      <div class="as-default" v-else>
        {{ item.type }}
      </div>
    </td>
    <td>
      <app-sel
        styling="inline"
        v-model="unit"
        key-name="label"
        :items="Object.keys(nutrient.units).map(item => {return {label: item}})"
      >
        <template v-slot="{ items }">
          <app-sel-opt
            :value="unit"
            v-for="unit in items"
          >
            {{ $ml.get(unit.label) }}
          </app-sel-opt>
        </template>
      </app-sel>
    </td>
    <td>
      <app-sel
        styling="inline"
        :items="extentions"
        key-name="id"
        label-name="name"
        v-model="item.ext"
        class="extentions"
      >
        <template v-slot="{ items }">
          <app-sel-opt
            :value="item"
            v-for="item in items"
            :key="item.id"
          >
            {{ item.name }}
          </app-sel-opt>
        </template>
      </app-sel>
    </td>
    <td class="value">
      <app-text-input
        v-if="this.item.type != 'N'"
        class="in-st"
        :value="convert()"
        @input="onInput"
        :min-width="`100px`"
        type="number"
        :digits-after-dot="2"
      />
      <app-text-input
        :readonly="isReadonly"
        :disabled="isReadonly"
        v-else
        class="in-st"
        :value="convert()"
        @input="onInput"
        type="number"
        :max="getMax()"
        :min-width="`100px`"
        :digits-after-dot="2"
      />
    </td>
    <td
      class="warning-level"
      :class="{
        'low': warningLvl === 'Low',
        'adequate': warningLvl === 'Adequate',
        'high': warningLvl === 'High',
        'excessive': warningLvl === 'Excessive',
        'none': warningLvl === 'None',
      }"
    >
      <template v-if="warningLvl">
        <div v-if="warningLvl.is_error" class="error">
          {{ $ml.get(warningLvl.msg) }}
        </div>
        <template v-else>
          {{ $ml.get(warningLvl) }}
        </template>
      </template>
    </td>
  </tr>
</template>

<script>
import { NutrientConverter } from '@/mixins/nutrient-converter.mixin';
import { UnitConverter } from '@/mixins/unit-converter.mixin';

export default {
  mixins: [ NutrientConverter, UnitConverter ],
  props: {
    item: {

    }
  },
  data() {
    return {
      selected: null,
      unit: 'ppm',

    }
  },
  methods: {
    getMax() {
      return this.$store.state.tests.soil.maxNCount;
    },

    onInput(value) {
      // converting view
      if (this.isSeveralTyped) {
        value = this.unconvertNutrientType(this.item.type, this.selected, value);
      }
      this.item.value = this.toPpm(this.item.type, this.unit, value);
      
      
      var lvl = this.$store.getters['tests/soil/getWarningLevel'](this.item.value, this.item.ext);
      this.item.interpretation = lvl ? this.$levelToInterpretation(lvl) : "None";

      const n_1 = this.$store.state.tests.soil.form.data.find(n => n.type === 'NNO3').value
      const n_2 = this.$store.state.tests.soil.form.data.find(n => n.type === 'NNH4').value
      const n_3 = this.$store.state.tests.soil.form.data.find(n => n.type === 'NNH2').value

      if(this.item.n_form ) {
        if(n_1 > 0 || n_2 > 0 || n_3 > 0) {
          this.$store.commit('tests/soil/computeN', {use_n_form: true});
        } else {
          if(this.item.value == null) {
              this.$store.commit('tests/soil/setMax', {value: 9999999});
              return false
          } else this.$store.commit('tests/soil/computeN', {use_n_form: false});
        }
        var n = this.$store.state.tests.soil.form.data.find(n => n.type === 'N');
        var l = this.$store.getters['tests/soil/getWarningLevel'](n.value, n.ext);
        n.interpretation = l ? this.$levelToInterpretation(l) : "None";
      }
    },

    // unconverting view
    convert() {
      // console.log(this.item.value)
      let val = this.item.value;
      if (this.isSeveralTyped) {
        val = this.convertNutrientType(this.item.type, this.selected, this.item.value);
      }

      val = this.toUnit(this.item.type, this.unit, val);
      return val && val > 0 ? val.toFixedGentle(2) : null;
      // return val;
    },
  },
  computed: {
    isReadonly () {
      const n_1 = this.$store.state.tests.soil.form.data.find(n => n.type === 'NNO3').value
      const n_2 = this.$store.state.tests.soil.form.data.find(n => n.type === 'NNH4').value
      const n_3 = this.$store.state.tests.soil.form.data.find(n => n.type === 'NNH2').value

      return (n_1 > 0 || n_2 > 0 || n_3 > 0) ? true : false
    },
    nutrient() {
      return this.$store.getters['nutrients/getNutrientByKey'](this.item.type);
    },
    isSeveralTyped() {
      return this.nutrient.types ? true : false;
    },
    extentions() {
      var ext;
      if (this.item.n_form) {
        ext = this.$store.getters['tests/soil/getGetExtsByNutrient']('N');
      } else {
        ext = this.$store.getters['tests/soil/getGetExtsByNutrient'](this.item.type);
      }
      return ext;
    },
    warningLvl() {
      try {
        var lvl = this.$store.getters['tests/soil/getWarningLevel'](this.item.value, this.item.ext);
      } catch (error) {
        return error;
      }

      // TODO: make translates instead of this
      return this.$store.getters['tests/soil/renderWarningLevel'](lvl);
    }
  },
  created() {
    if(this.isSeveralTyped) {
      this.selected = this.nutrient.types[0].label;
    }
  },
}
</script>

<style lang="scss" scoped>

.test-result-row {
  td {
    padding: 10px 0 10px 10px;

    &.value {
      min-width: 100px;
    }
    &.nutrient {
      .app-sel {
        // padding-left: 0;
        &::v-deep {
          &.styling-inline {
            width: 91px;
          }
        }
      }

      .as-default {
        padding-left: 17px;
      }
    }

    .extentions {
      width: 100%;
    }

    &.warning-level {
      &.none {
        color: #858585;
        font-weight: bold;
      }
      &.low {
        color: #5EC19B;
        font-weight: bold;
      }
      &.adequate {
        color: #A7B975;
        font-weight: bold;
      }
      &.high {
        color: #F2B14E;
        font-weight: bold;
      }
      &.excessive {
        color: #EC5A60;
        font-weight: bold;
      }

      .error {
        display: inline-flex;
        color: #EC5A60;
        background: rgba($color: #EC5A60, $alpha: 0.15);
        font-weight: 500;
        border: 1px solid #EC5A60;
        font-size: 14px;
        padding: 2px 5px;
        border-radius: 3px;
      }
    }
  }
}

</style>
